import styled from 'styled-components';

export const StyledResourceOptionCard = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  cursor: pointer;
  gap: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.foreground};
  }
`;

export const IconContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.foreground};
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
